import { Autocomplete, Box, FormLabel, Grid, TextField } from "@mui/material";
import useFormStyles from "../../styles/useFormStyles";
import { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import Loader from "./Loader";

export interface BasicAutoCompletePropTypes {
  options: string[];
  setState: Function;
  stateKey: string;
  secondaryStateKey?: string | any;
  clear?: boolean;
  label?: string;
  required?: boolean;
  defaultValue?: string;
  readonly?: boolean;
  error?: boolean;
  helperText?: string;
  loading?: boolean;
  onFocus?: (e: any) => void;
}

const BasicAutoComplete = (props: BasicAutoCompletePropTypes) => {
  const {
    options,
    setState,
    stateKey,
    secondaryStateKey,
    clear,
    label,
    required,
    defaultValue,
    readonly,
    error,
    helperText,
    loading,
    onFocus,
  } = props;
  const [inputState, setInputState] = useState<any>(
    defaultValue ? defaultValue : ""
  );
  const formStyles = useFormStyles();

  const theme = useTheme();
  const readOnlyStyles: React.CSSProperties = {
    backgroundColor: theme.color?.readOnly,
  };

  useEffect(() => {
    setState((prev: any) => {
      return {
        ...prev,
        [stateKey]: inputState?.label,
        [secondaryStateKey]: inputState?.type,
      };
    });
  }, [inputState]);

  return (
    <Box>
      <FormLabel
        sx={{
          ...formStyles.formLabel,
          textAlign: "left",
        }}
      >
        {label}
      </FormLabel>
      <Autocomplete
        readOnly={readonly}
        key={clear ? "autoCompleteReset" : "autoComplete"}
        onChange={(e: any, newValue: string | null) =>
          setInputState(newValue ?? "")
        }
        value={inputState}
        disableClearable={true}
        size="small"
        id="combo-box-demo"
        options={options}
        renderInput={(params) => (
            <TextField
              {...params}
              required={required ?? false}
              style={readonly ? readOnlyStyles : {}}
              error={error}
              onFocus={onFocus}
              helperText={helperText}
              />
        )}
      />
    </Box>
  );
};

export default BasicAutoComplete;
